export default "__VITE_ASSET__574a14d0__"